const allocation = (type) => { return `${process.env.VUE_APP_URL}/api/v1/allocation/indirect-cost-pool-${type}-allocations/` };
const allocationTable = `${process.env.VUE_APP_URL}/api/v1/allocation/cost-pool-allocations/`;
const allocationCalculation = `${process.env.VUE_APP_URL}/api/v1/calculation`
const cost = `${process.env.VUE_APP_URL}/api/v1/cost`;
import { validateResponseError } from "@/store/utils.js";

export default {
  namespaced: true,
  state: {
    management: {
      baseUrl: ({ scenario, limit, order, offset, searchTerm }) => `${allocationTable}?scenario=${scenario}&limit=${limit}${order}${offset}${searchTerm}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Cost Pool Source",
          field: "source_name",
        },
        {
          label: "Cost Pool Destination",
          field: "destination_name",
        },
        {
          label: "Allocation type",
          field: "allocation_type",
        },
        {
          label: "Percentage",
          field: "percentage",
          symbol: "%",
          type: "number",
        },
        {
          label: "Driver",
          field: "cost_pool_driver_name",
        },
        {
          label: "",
          field: "manage",
        },
      ],
      rows: [],
      orderField:'',
      orderDict:{
        source_name:"source__name",
        destination_name:"destination__name",
        allocation_type:"allocation_type",
        percentage:"percentage",
        cost_pool_driver_name:"driver__name",
      },
    },
    source: {
      baseUrl: ({ scenario, limit, order, offset }) => `${allocationCalculation}/indirect-results/by-source/?scenario=${scenario}&limit=${limit}${order}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Cost pool name",
          field: "source_name",
        },
        {
          label: "Original amount",
          field: "original_amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        // {
        //   label: "Allocated amount",
        //   field: "allocated_amount",
        //   type: 'number',
        //   formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        // },
        {
          label: "Status",
          field: "status",
          width: "350px",
        },
      ],
      rows: [],
      orderField:'',
      orderDict:{
        source_name:"source__name"
      },
    },
    destination: {
      baseUrl: ({ scenario, limit, order, offset }) => `${allocationCalculation}/indirect-results/by-destination/?scenario=${scenario}&limit=${limit}${order}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Cost Pool",
          field: "destination_name",
        },
        {
          label: "Amount",
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        },
        {
          label: "Cost per Minute",
          field: "cost_per_minute",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; },
          hidden: true,
          thClass: 'tdabc-background-header',
          tdClass: 'tdabc-background',
        }
      ],
      rows: [],
      orderField:'',
      orderDict:{
        destination_name:"destination__name"
      },
    },
    aggregated: {
      baseUrl: ({ scenario, limit, order, offset }) => `${allocationCalculation}/indirect-results/?scenario=${scenario}&limit=${limit}${order}${offset}`,
      previousUrl: null,
      nextUrl: null,
      currentUrl: null,
      count: null,
      pageLength: 10,
      offset: 0,
      columns: [
        {
          label: "Source",
          field: "source_name",
        },
        {
          label: "Destination",
          field: "destination_name",
        },
        {
          label: "Allocated amount",
          field: "amount",
          type: 'number',
          formatFn: (value) => { return `${parseFloat(value).toFixed(2)}`; }
        }
      ],
      rows: [],
      orderField:'',
      orderDict:{
        source_name:"source__name",
        destination_name: "destination__name"
      },
    },
    createAllocationData: {
      source: null,
      destination: null,
      type: "PERCENTAGE",
      percentage: 100,
      driver: null,
    },
    indirectCostPoolOptions: [],
    costPoolOptions: [],

    strategyOptions: [
      {
        id: "not_allocate",
        name: "Not allocate"
      },
      {
        id: "rebalance",
        name: "Rebalance"
      }
    ],
    resultsStrategy: "not_allocate", //rebalance

    lastCalculation: [{
      calculation_id: null,
      finished_at: null, 
      requested_by_user: null,
    }],
    costPoolDriverValuesOptions: [],
    debug:{
      mode: "logs",
      errors:[],
      logs:[]
    }
  },
  getters:{
    getDebugData(state){
      return state.debug[state.debug.mode];
    }
  },
  mutations: {
    SET_SEARCH_TERM(state, data){
      state[data.subStore].searchTerm = data.searchTerm
    },
    SET_OFFSET(state, data) {
      state[data.subStore].offset = state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength < 0 ? 0 : state[data.subStore].pageLength * data.currentPage - state[data.subStore].pageLength
    },
    // Set all cost pools and filter by indirect
    SET_COSTPOOL_OPTIONS(state, data) {
      if(!data){
        return;
      }
      state.costPoolOptions = data
      state.indirectCostPoolOptions = data.filter(el => el.is_direct == false)
    },
    SET_DESTINATION_COSTPOOL_OPTIONS(state, data) {
      state.costPoolOptions = data
    },

    SET_CREATE_ALLOCATION_DATA(state, data) {
      state.createAllocationData = data;
    },
    SET_ALLOCATION_PERCENTAGE(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.percentage = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_SOURCE(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.source = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_TYPE(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.type = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_DRIVER(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.driver = data;
      state.createAllocationData = allocationData;
    },
    SET_ALLOCATION_DESTINATION(state, data) {
      let allocationData = { ...state.createAllocationData }
      allocationData.destination = data;
      state.createAllocationData = allocationData;
    },
    SET_COSTPOOL_DRIVER_VALUES_OPTIONS(state, data) {
      state.costPoolDriverValuesOptions = data
    },
    CLEAR_ALLOCATION_DATA(state) {
      state.createAllocationData = {
        source: null,
        destination: null,
        percentage: 100,
        type: "PERCENTAGE",
        driver: null
      };
    },
    SET_RESULTS_STRATEGY(state, data) {
      state.resultsStrategy = data;
    },
    CLEAR_RESULTS_DATA(state) {
      state.source.rows = [];
      state.destination.rows = [];
      state.lastCalculation = [{
        calculation_id: null,
        finished_at: null
      }]
    },
    SET_LAST_CALCULATION(state, data) {
      if(!data){
        return;
      }
      state.lastCalculation = data;
    },
    ///////////////////////////////////////////////////////////////////////////
    SET_COUNT(state, data) {
      state[data.subStore].count = data.count;
    },
    SET_NEXT(state, data) {
      state[data.subStore].nextUrl = data.next;
    },
    SET_PREVIOUS(state, data) {
      state[data.subStore].previousUrl = data.previous;
    },
    SET_CURRENT(state, data) {
      state[data.subStore].currentUrl = data.current;
    },
    SET_ROWS(state, data) {
      if(!data.rows){
        return;
      }
      let copy = { ...state[data.subStore] }
      copy.rows = data.rows;
      state[data.subStore] = copy;
    },
    SET_COLUMNS_TDABC(state, data) {
      if (data.subStore === "destination") {
        const has_cost_per_minute = data.rows.some(item => "cost_per_minute" in item)
        if (has_cost_per_minute) {
          state[data.subStore].columns.forEach(element => {
            if (element.label == "Cost per Minute") { element.hidden = false }
          });
        }else{
          state[data.subStore].columns.forEach(element => {
            if (element.label == "Cost per Minute") { element.hidden = true }
          });
        }
      }
    },
    SET_PAGE_LENGTH(state, data) {
      state[data.subStore].pageLength = data.pageLength;
    },
    CLEAR_TABLE_DATA(state, data){
      if(data.subStore){
        state[data.subStore].rows = [];
      }
    },
    SET_ORDER_FIELD(state, data){
      if(data.subStore && state[data.subStore].orderDict){
        switch(data.orderType){
          case 'asc':
            state[data.subStore].orderField = state[data.subStore].orderDict[data.orderField];
            break;
          case 'desc':
            let orderField = state[data.subStore].orderDict[data.orderField]
            state[data.subStore].orderField = orderField ? `-${orderField}`: null;
            break;
          default:
            state[data.subStore].orderField = null;
            break;
        }
      }
    },
    SET_DEBUG_LOGS(state, data){
      state.debug.logs = data;
    },
    SET_DEBUG_ERRORS(state, data){
      state.debug.errors = data;
    },
    SET_DEBUG_MODE(state, data){
      state.debug.mode = data;
    },

  },
  actions: {
    getTableData({ state, commit }, { context, scenarioId, subStore }) {
      let order = state[subStore].orderField ? `&ordering=${state[subStore].orderField}` : ''
      let offset = state[subStore].offset ? `&offset=${state[subStore].offset}` : ''
      let searchTerm = state[subStore].searchTerm ? `&search=${state[subStore].searchTerm}` : ''
      let getData =
        state[subStore].currentUrl || state[subStore].baseUrl({ scenario: scenarioId, limit: state[subStore].pageLength, order: order, offset: offset, searchTerm: searchTerm});
      return context.$http.get(getData).then((res) => {
        commit("SET_COUNT", { subStore, count: res.data.count });
        commit("SET_NEXT", { subStore, next: res.data.next });
        commit("SET_PREVIOUS", { subStore, previous: res.data.previous });
        commit("SET_ROWS", { subStore, rows: res.data.results ? res.data.results : res.data });
        if(subStore == "destination") commit("SET_COLUMNS_TDABC", {subStore, rows: res.data.results})
      });
    },
    setNextAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].nextUrl });
    },
    setPreviousAsCurrent({ state, commit }, { subStore }) {
      commit("SET_CURRENT", { subStore, current: state[subStore].previousUrl });
    },
    setAllocationSource({ commit }, { context, scenarioId, value }) {
      commit("SET_ALLOCATION_SOURCE", value);
      let getUrl = `${cost}/pools/?scenario=${scenarioId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          let filteredCP = res.data.filter(cp => cp.id != value)
          commit("SET_DESTINATION_COSTPOOL_OPTIONS", filteredCP);
        });
    },
    getAllocationsTable({ commit }, { context, scenarioId }) {
      let getUrl = `${allocationTable}?scenario=${scenarioId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_TABLE_DATA", res.data)
        });
    },
    getCostPools({ commit }, { context, scenarioId }) {
      let getUrl = `${cost}/pools/?scenario=${scenarioId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_COSTPOOL_OPTIONS", res.data);
        });
    },
    getCostPoolDriver({ commit }, { context, modelId }) {
      let getUrl = `${cost}/pool-drivers/?model=${modelId}`;
      return context.$http.get(getUrl)
        .then((res) => {
          commit("SET_COSTPOOL_DRIVER_VALUES_OPTIONS", res.data);
        });
    },
    createUpdateSecondAllocation({ state }, { context, scenarioId, mode }) {
      let dataToPost = { ...state.createAllocationData };
      dataToPost.ratio = (dataToPost.percentage / 100).toFixed(6);
      dataToPost.scenario = scenarioId

      dataToPost.source = state.indirectCostPoolOptions.filter(cp => cp.identifier == dataToPost.source)[0].id;
      dataToPost.destination = state.costPoolOptions.filter(cp => cp.identifier == dataToPost.destination)[0].id;

      let type = state.createAllocationData.type.toLowerCase();
      if (mode == "UPDATE") {
        let putUrl = `${allocation(type)}${state.createAllocationData.id}/`;
        return context.$http.patch(putUrl, dataToPost);
      }
      let postUrl = `${allocation(type)}`;
      return context.$http.post(postUrl, dataToPost);
    },
    deleteAllocation({ state }, { context, id, type }) {
      let deleteUrl = `${allocationTable}${id}`;
      return context.$http.delete(deleteUrl);
    },
    // CALCULATION
    getLastCalculationDetails({ commit, dispatch }, { context, scenarioId }) {
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=INDIRECT_COST_POOL_TO_COST_POOL`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if(res.data[res.data.length-1].calculation_status !== "FINISHED"){
            throw new Error("No calculation");
          }
        })
        .catch(err => {
          validateResponseError(this, err, "secondAllocation");
        })
    },
    getLastCalculation({ commit, dispatch }, { context, scenarioId }) {
      let resultsUrl = `${allocationCalculation}/calculations/?scenario=${scenarioId}&category=INDIRECT_COST_POOL_TO_COST_POOL`;
      return context.$http.get(resultsUrl)
        .then(res => {
          commit("SET_LAST_CALCULATION", res.data)
          if(res.data[res.data.length-1].calculation_status !== "FINISHED"){
            throw new Error("No calculation");
          }
        }).catch(err => {
          validateResponseError(this, err, "secondAllocation");
        })
    },
    calculateResults({ state, dispatch, commit }, { context, scenarioId }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl = `${allocationCalculation}/indirect-results/generate/`;
      return context.$http.post(resultsUrl, { scenario: scenarioId, strategy: state.resultsStrategy })
        .then(res => {
          commit("SET_LAST_CALCULATION", [res.data])
        });
    },
    getSourceAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "source", scenarioId })
    },
    getDestinationAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "destination", scenarioId })
    },
    getAggregatedAllocationResults({ dispatch }, { context, scenarioId }) {
      dispatch("getTableData", { context, subStore: "aggregated", scenarioId })
    },
    getCalculationLogs({commit, state},{context}){
      let resultUrl = `${process.env.VUE_APP_URL}/api/v1/calculation/logs/?calculation=${state.lastCalculation[0].calculation_id}`
      return context.$http.get(resultUrl)
        .then(res => {
          commit("SET_DEBUG_LOGS", res.data[0].detail )
        }).catch(err => {
          validateResponseError(this, err, "secondAllocation");
        })
    },
    getCalculationErrors({commit},{}){
      commit("SET_DEBUG_ERRORS",["Not implemented"]);
    },
    cancelCalculation({ dispatch, commit }, { context, scenarioId, calculationID }) {
      commit("CLEAR_RESULTS_DATA");
      let resultsUrl =  `${allocationCalculation}/calculations/stop-calculation/`;
      let payload = {
        calculation_id: calculationID
      }
      return context.$http.post(resultsUrl, payload)
      .then(() => {
        return dispatch("getLastCalculationDetails",{context:context, scenarioId: scenarioId})
      });
    },
  },
}
